<h1 class="h3"><font color="#bd0f0f">Contract Templates and Guidance Documents </font></h1>
<hr />
<main>
  <h2 class="h4">
    <label>
      Keyword Document Name Search
      <input (keyup)="applyFilter($event)" placeholder="ex. Contracts" #input>
    </label>
  </h2>

  <br />

  @if (docsLoading) {
    <div style="text-align:center;"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>
  }

  @for (docType of docTypeList; track docType) {
    <mat-accordion [hidden]="'HSC HEALTHCARE-RELATED TEMPLATES' == docType">
      <mat-expansion-panel hideToggle>
        <p>This is the primary content of the panel.</p>
      </mat-expansion-panel>
      <mat-expansion-panel (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
        [expanded]="hasMatchInType(docType)">
        <mat-expansion-panel-header>
          <mat-panel-description>
            {{ docType }}
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="example-container mat-elevation-z8">
          <table [hidden]="docsLoading" mat-table [dataSource]="dataSource_docs">
            <ng-container matColumnDef="documentType">
              <th mat-header-cell *matHeaderCellDef style="text-align:left" scope="col">  Document Type </th>
              <td mat-cell *matCellDef="let element">
                {{element.DocumentType}}
              </td>
            </ng-container>
            <ng-container matColumnDef="documentSubType">
              <th mat-header-cell *matHeaderCellDef style="text-align:left" scope="col">  Sub Document Type </th>
              <td mat-cell *matCellDef="let element">{{element.DocumentSubType}}  </td>
            </ng-container>
            <ng-container matColumnDef="documentDesc">
              <th mat-header-cell *matHeaderCellDef style="text-align:left" scope="col">  File Description </th>
              <td mat-cell *matCellDef="let element">
                {{element.DocumentDesc}}
                @if (element.DocumentNew) {
                  <img src="./images/newstar.jfif" width="28px" />
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="dateReceived">
              <th mat-header-cell *matHeaderCellDef style="text-align:left" scope="col">  Date Added </th>
              <td mat-cell *matCellDef="let element">{{element.DateReceived}}  </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef style="text-align:left" scope="col">   </th>
              <td mat-cell *matCellDef="let element">
                @if (element.AuthRequired) {
                  <button class="fa" (click)="OpenDoc(element.XtenderDocRef)">&nbsp;Download </button>
                }
                @if (!element.AuthRequired) {
                  <button class="fa" (click)="OpenDoc(element.XtenderDocRef)">Download </button>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="tags">
              <th mat-header-cell *matHeaderCellDef style="text-align:left" scope="col">   </th>
              <td mat-cell *matCellDef="let element" [hidden]="true">{{element.Tags}}  </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns_docs"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns_docs; " [hidden]="row.DocumentType!== docType"></tr>
          </table>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  }



  @for (docType of docTypeList; track docType) {
    <mat-accordion [hidden]="'HSC HEALTHCARE-RELATED TEMPLATES' !== docType">
      <mat-expansion-panel hideToggle>
        <p>This is the primary content of the panel.</p>
      </mat-expansion-panel>
      <mat-expansion-panel (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
        [expanded]="hasMatchInHSCType(docType)">
        <mat-expansion-panel-header>
          <mat-panel-description>
            {{ docType  }}
          </mat-panel-description>
        </mat-expansion-panel-header>
        @for (docSubType of docSubTypeList; track docSubType) {
          <mat-accordion [hidden]="'NONE' == docSubType">
            <mat-expansion-panel hideToggle>
              <p>This is the primary content of the panel.</p>
            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState = true"
              (closed)="panelOpenState = false"
              [expanded]="hasMatchInHSCSubType(docSubType)">
              <mat-expansion-panel-header>
                <mat-panel-description>
                  {{ docSubType  }}
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="example-container mat-elevation-z8">
                <table [hidden]="docsLoading" mat-table [dataSource]="dataSource_HSCdocs">
                  <ng-container matColumnDef="documentType">
                    <th mat-header-cell *matHeaderCellDef style="text-align:left" scope="col">  Document Type </th>
                    <td mat-cell *matCellDef="let element">{{element.DocumentType}}  </td>
                  </ng-container>
                  <ng-container matColumnDef="documentSubType">
                    <th mat-header-cell *matHeaderCellDef style="text-align:left" scope="col">   Document Type </th>
                    <td mat-cell *matCellDef="let element">{{element.DocumentSubType}}  </td>
                  </ng-container>
                  <ng-container matColumnDef="documentDesc">
                    <th mat-header-cell *matHeaderCellDef style="text-align:left" scope="col">  File Description </th>
                    <td mat-cell *matCellDef="let element">
                      {{element.DocumentDesc}}
                      @if (element.DocumentNew) {
                        <img src="./images/newstar.jfif" width="28px" />
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="dateReceived">
                    <th mat-header-cell *matHeaderCellDef style="text-align:left" scope="col">  Date Added </th>
                    <td mat-cell *matCellDef="let element">{{element.DateReceived}}  </td>
                  </ng-container>
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef style="text-align:left" scope="col">   </th>
                    <td mat-cell *matCellDef="let element">
                      @if (element.AuthRequired) {
                        <button class="fa" (click)="OpenDoc(element.XtenderDocRef)">&nbsp;Download </button>
                      }
                      @if (!element.AuthRequired) {
                        <button class="fa" (click)="OpenDoc(element.XtenderDocRef)">Download </button>
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="tags">
                    <th mat-header-cell *matHeaderCellDef style="text-align:left" scope="col">   </th>
                    <td mat-cell *matCellDef="let element" [hidden]="true">{{element.Tags}}  </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns_docs"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns_docs; " [hidden]="row.DocumentSubType!== docSubType"></tr>
                </table>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        }
      </mat-expansion-panel>
    </mat-accordion>
  }
</main>



